import script from "./detail.vue?vue&type=script&lang=jsx&setup=true"
export * from "./detail.vue?vue&type=script&lang=jsx&setup=true"

import "./detail.vue?vue&type=style&index=0&id=371a58d0&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-371a58d0"]])

export default __exports__